import React from 'react';

import { ShieldCheck } from 'lucide-react';
import mdotLogo from '../../images/certifications/mdot-mbe.png';
import samLogo from '../../images/certifications/logo-sam.svg';
import sbaLogo from '../../images/certifications/sba-hubzone.png';
import isoLogo from '../../images/certifications/iso-9001.png';
import './CertificationsTrust.scss';

const CertificationsTrust = () => {
    const certifications = [
        {
            logo: samLogo,
            alt: 'SAM.gov registered',
            title: 'SAM.gov Registered',
            code: 'UEI D244FV1CHVP4',
            description: 'Active registration with the System for Award Management.',
            color: 'blue',
        },
        {
            logo: mdotLogo,
            alt: 'Maryland Department of Transportation MBE / DBE / SBE Certified',
            title: 'MBE / DBE / SBE Certified',
            code: 'Cert. No. 24-371',
            description: 'Minority Business Enterprise certified by MDOT.',
            color: 'primary',
            logoSize: 'lg',
        },
        {
            logo: sbaLogo,
            alt: 'SBA HUBZone Certified',
            title: 'HUBZone Certified',
            code: '',
            description: 'U.S. Small Business Administration HUBZone certified small business.',
            color: 'cyan',
            logoSize: 'lg',
        },
        {
            logo: isoLogo,
            alt: 'ISO 9001:2015 Certified',
            title: 'ISO 9001:2015 Certified',
            code: 'Quality Management',
            description: 'Certified to the ISO 9001:2015 international quality management standard.',
            color: 'accent',
        },
    ];

    return (
        <section className="jk-certs">
            <div className="jk-certs__container">
                    <div className="jk-certs__header">
                        <span className="jk-section-label">
                            <ShieldCheck size={16} />
                            Trust & Compliance
                        </span>
                        <h2 className="jk-certs__title">
                            Certified &
                            <span className="jk-certs__title-highlight"> Compliant</span>
                        </h2>
                        <p className="jk-certs__subtitle">
                            Our certifications and registrations demonstrate our commitment to excellence and regulatory compliance.
                        </p>
                    </div>

                <div className="jk-certs__grid">
                    {certifications.map((cert, index) => (
                            <div key={index} className={`jk-certs__card jk-certs__card--${cert.color}`}>
                                <div className={`jk-certs__card-logo${cert.logoSize === 'lg' ? ' jk-certs__card-logo--lg' : ''}`}>
                                    <img src={cert.logo} alt={cert.alt} loading="lazy" />
                                </div>
                                <h3 className="jk-certs__card-title">{cert.title}</h3>
                                <span
                                    className={`jk-certs__card-code${cert.code ? '' : ' jk-certs__card-code--placeholder'}`}
                                    aria-hidden={cert.code ? undefined : true}
                                >
                                    {cert.code || ' '}
                                </span>
                                <p className="jk-certs__card-desc">{cert.description}</p>
                            </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CertificationsTrust;
